// services/dashboard.service.js
import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const getStatsData = async (businessId, startDate, tillDate) => {
  try {
    // Ensure we have valid dates
    let params = new URLSearchParams();
    
    if (startDate && tillDate) {
      // Format dates to YYYY-MM-DD
      const formattedStart = formatDateString(startDate);
      const formattedEnd = formatDateString(tillDate);
      
      params.append('startDate', formattedStart);
      params.append('endDate', formattedEnd);
    } else {
      // Default to last 3 months
      const now = new Date();
      const threeMonthsAgo = new Date(now);
      threeMonthsAgo.setMonth(now.getMonth() - 3);
      
      params.append('startDate', formatDateString(threeMonthsAgo));
      params.append('endDate', formatDateString(now));
    }
    
    const url = `${URL}/dashboard/${businessId}?${params.toString()}`;
    console.log("Fetching dashboard data from:", url);
    
    let resp = await http.get(url);
    return resp;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    return errorHandler(error);
  }
};

// Helper function to format dates
const formatDateString = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    console.warn("Invalid date:", date);
    return '';
  }
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};